module.exports = __webpack_public_path__ + "img/lens-160-plus-07.294447f0.png";